import { Typography } from "@mui/material";

import { Product } from "api/memberPortal/project/product/product.types";
import { withForm } from "components/Forms/AppForm";

import EcrProductSelect from "../components/EcrProductSelect";

import { ecrFormDefaultValues } from "./ecrFormDefaultValues";

const EcrProductSection = withForm({
  defaultValues: ecrFormDefaultValues,
  props: {
    isProductLocked: false,
    product: undefined as Product | undefined,
    onProductSelect: async (_productId: number) => {},
  },
  render: function Render({ form, isProductLocked, product, onProductSelect }) {
    const productLabel = product
      ? `VID ${product.v_id} - ${product.product_name}`
      : "";

    return (
      <form.FormSection title="Product" columns={1}>
        <form.AppField
          name="product"
          listeners={{
            // When product changes: reset dependent fields, then
            // fetch PP options for cascading dropdowns and auto-set process location
            onChange: ({ value }) => {
              if (isProductLocked) return;
              form.resetField("protectionProfile");
              form.resetField("technicalDecisions");

              if (!value) return;
              // TODO: fix this typing
              onProductSelect(value.value);
            },
          }}
        >
          {() =>
            isProductLocked ? (
              <Typography variant="body1" color="text.secondary">
                {productLabel}
              </Typography>
            ) : (
              <EcrProductSelect />
            )
          }
        </form.AppField>
      </form.FormSection>
    );
  },
});

export default EcrProductSection;
